import { get } from 'lodash-es'


import { api } from '@/utils/api';
export interface IGetUploadUrlOptions {
  api?: string
  headers?: HeadersInit
  payload?: {
    filename: string
    type: string
    action?: string
  }
  signal?: AbortSignal
}

export async function getS3UploadUrl(options: IGetUploadUrlOptions) {
  const { api = ' /api/upload/sign', payload, headers } = options

  const result = await fetch(api, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify(payload),
    signal: options?.signal,
  })

  if (!result.ok) {
    const data = await result.json()
    throw new Error(get(data, 'errorMessage') || 'Response is not ok')
  }

  const data: {
    /** 过期时间 */
    expired: number
    /** 文件待上传地址 */
    sign: string
    /** 图片地址  */
    accessURL: string
  } = await result.json()

  return data
}

export interface IUploadToS3Options {
  onProgress?: (value: number) => void
  onError?: (error: Error) => void
  onAbort?: () => void
  onSuccess?: (xhr: XMLHttpRequest) => void
  errorMessage?: string
}

export function uploadToS3(
  url: string,
  data: Blob,
  options?: IUploadToS3Options,
) {
  const {
    onProgress,
    onError,
    onAbort,
    onSuccess,
    errorMessage = 'File upload failed',
  } = options || {}
  const xhr = new XMLHttpRequest()
  xhr.upload.addEventListener('progress', (c) => {
    onProgress?.(Math.floor((c.loaded / c.total) * 100))
  })
  xhr.addEventListener('load', () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      onSuccess?.(xhr)
    } else {
      onError?.(new Error(errorMessage))
    }
  })
  xhr.addEventListener('error', () => onError?.(new Error(errorMessage)))
  xhr.addEventListener('abort', () => onAbort?.())
  xhr.open('PUT', url, true)

  xhr.setRequestHeader(
    'Content-Type',
    data.type.startsWith('text/') ? `${data.type};charset=utf-8` : data.type,
  )
  try {
    xhr.send(data)
  } catch (error) {
    onError?.(new Error(errorMessage))
  }
  return xhr
}
